import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { authApi, type CurrentUser } from '@/api/auth';
import { setToken, getToken } from '@/api/client';

export const useAuthStore = defineStore('auth', () => {
  const user = ref<CurrentUser | null>(null);
  const token = ref<string | null>(getToken());

  const isAuthenticated = computed(() => token.value !== null && user.value !== null);

  async function hydrate(): Promise<void> {
    if (!token.value) return;
    try {
      user.value = await authApi.me();
    } catch {
      logout();
    }
  }

  async function loginEmail(email: string, password: string): Promise<void> {
    const res = await authApi.loginEmail(email, password);
    setToken(res.access_token);
    token.value = res.access_token;
    user.value = await authApi.me();
  }

  async function verifyPhone(phone: string, code: string): Promise<void> {
    const res = await authApi.verifyCode(phone, code);
    setToken(res.access_token);
    token.value = res.access_token;
    user.value = await authApi.me();
  }

  function logout(): void {
    setToken(null);
    token.value = null;
    user.value = null;
  }

  return { user, token, isAuthenticated, hydrate, loginEmail, verifyPhone, logout };
});
